export default "__VITE_ASSET__MPOF_lLe__"